import { render, staticRenderFns } from "./AbnormalNotificationDialog.vue?vue&type=template&id=783ddfbc"
import script from "./AbnormalNotificationDialog.vue?vue&type=script&lang=js"
export * from "./AbnormalNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports